export const REQUESTING_AUTH = "IAM.REQUESTING_TOKEN";
export const ERROR_REQUESTING_AUTH = "IAM.ERROR.REQUESTING_TOKEN";
export const RECEIVED_AUTH = "IAM.RECEIVED_TOKEN";
export const REFRESHING_TOKEN = "IAM.REFRESHING_TOKEN";
export const REFRESHED_TOKEN = "IAM.REFRESHED_TOKEN";
export const LOGOUT = "IAM.LOGOUT";

export const CREATING_ACCOUNT = "IAM.CREATING.ACCOUNT";
export const CREATED_ACCOUNT = "IAM.CREATED.ACCOUNT";
export const ERROR_CREATING_ACCOUNT = "IAM.ERROR.CREATING_ACCOUNT";
